import { PartnerApplicationMachineContext } from '~domains/partner-application/entities/application';
import { ProfileFormNavigation } from '~domains/profile/@x/partner-application';

import { ScreenAsidePortal } from '~shared/ui/screen';

import { PartnerApplicationFormNavigation } from '../../partner-application-form-navigation';
import {
  getActiveBusinessNavStepId,
  getActivePartnerNavSectionId,
} from '../lib/get-active-partner-application-nav-step';

export const PartnerApplicationFormNavigationConnected = () => {
  const activeSectionId = PartnerApplicationMachineContext.useSelector(
    getActivePartnerNavSectionId
  );
  const activeStepId = PartnerApplicationMachineContext.useSelector(
    getActiveBusinessNavStepId
  );
  const isNavigationHidden = PartnerApplicationMachineContext.useSelector(
    (state) =>
      state.matches('submitted') ||
      state.matches({ businessBlock: 'continueAirtable' })
  );

  if (isNavigationHidden) {
    return null;
  }

  return (
    <ScreenAsidePortal>
      <nav
        aria-label="Partner application form navigation"
        className="flex flex-col"
      >
        <ProfileFormNavigation />
        <PartnerApplicationFormNavigation
          activeStepId={activeStepId}
          activeSectionId={activeSectionId}
        />
      </nav>
    </ScreenAsidePortal>
  );
};
